import Vue from 'vue'
import Router from 'vue-router'
//import Home from './components/HelloWorld.vue'
import LoginPage from './views/LoginPage.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/SupplierManage/SupplierChain/',
            name: 'SupplierChain',
            component: () => import('./views/Pages/SupplierChain/SupplierChain.vue'),
            meta: {
                requireAuth: true,
                keepAlive: false // 需要被缓存
            }
        },
        {
            path: '/InventoryManagement/ShippingDateReport/',
            name: 'ShippingDateReport',
            component: () => import('./views/Pages/ShippingDateReport/ShippingDateReport.vue'),
            meta: {
                requireAuth: true,
                keepAlive: false // 需要被缓存
            }
        },
        {
            path: '/OrderManage/OrderDetailList/',
            name: 'OrderDetailList',
            component: () => import('./views/Pages/OrderDetailList/OrderDetailList.vue'),
            meta: {
                requireAuth: true,
                keepAlive: false // 需要被缓存
            }
        },
        {
            path: '/CustManage/QuoteInquiry/',
            name: 'QuoteInquiry',
            component: () => import('./views/Pages/QuoteInquiry/QuoteInquiry.vue'),
            meta: {
                requireAuth: true,
                keepAlive: false // 需要被缓存
            }
        },
        {
            path: '/CustManage/CustomerInquiry/',
            name: 'CustomerInquiry',
            component: () => import('./views/Pages/CustomerInquiry/CustomerInquiry.vue'),
            meta: {
                requireAuth: true,
                keepAlive: false // 需要被缓存
            }
        },
        {
            path: '/ProductManage/ItemMasterInquiry/',
            name: 'ItemMasterInquiry',
            component: () => import('./views/Pages/ItemMasterInquiry/ItemMasterInquiry.vue'),
            meta: {
                requireAuth: true,
                keepAlive: false // 需要被缓存
            }
        },
        {
            path: '/PurchaseRequestManage/PurchaseRequestQuery/',
            name: 'PurchaseRequestQuery',
            component: () => import('./views/Pages/PurchaseRequestQuery/PurchaseRequestQuery.vue'),
            meta: {
                requireAuth: true,
                keepAlive: false // 需要被缓存
            }
        },
        {
            path: '/',
            name: 'home',
            component: () => import('./views/MainMenu.1.vue'),
        },
        {
            path: '/login',
            name: 'login',
            component: LoginPage
        }, {
            path: '/menu',
            name: 'mainMenu',
            component: () => import('./views/MainMenu.1.vue'),
            meta: {
                requireAuth: false
            }
        },
        , {
            path: '/submenu/:path',
            name: 'subMenu',
            component: () => import('./views/MainMenu.2.vue'),
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/APP001/',
            name: 'APP001',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/App001.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/SalesAnalysisManage/SalesAmountStatisticsAFAU/',
            name: 'SA3011',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/App001.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/APP002/',
            name: 'SA2220',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/App002.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/APP003/',
            name: 'APP003',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/App003.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/SalesAnalysisManage/CustomerSalesAnnualStatistics/',
            name: 'SA2141',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/App003.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/APP004/',
            name: 'SA2192',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/App004.vue'),
            meta: {
                requireAuth: true
            }
        },

        {
            path: '/AccountReceivableManage/ARTBARReport/',
            name: 'ARTBARReport',
            component: () => import(/* webpackChunkName: "about" */ '@/views/Pages/AccountReceivableManage/ARTBARReport.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/PU50041/',
            name: 'PU50041',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/Calendar.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/EForm/Signoff/:viewtype?',
            name: 'Signoff',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/SignatureForm.vue'),
            meta: {
                requireAuth: true,
                keepAlive: false // 需要被缓存
            }
        },
        {
            path: '/EForm/LeaveForm/',
            name: 'LeaveForm',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/LeaveForm.vue'),
            meta: {
                requireAuth: true,
                keepAlive: false // 需要被缓存
            }
        },
        {
            path: '/EForm/WorkFlowInquiryPage/:viewtype?',
            name: 'BP3120A',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/WorkFlowInquiry.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/ProductManage/ProductPicSearch/:viewtype?',
            name: 'ProductImage',
            component: () => import(/* webpackChunkName: "about" */ '@/views/Pages/ProductImage.vue'),
            meta: {
                requireAuth: true
            }
        },
        // {
        //   path: '/Test/Scan/', ///Test/Scan
        //   name: 'TEST01A',
        //   component: () => import(/* webpackChunkName: "about" */ './views/Pages/Test/Scan.vue'),
        //   meta: {
        //     requireAuth: true
        //   }
        // },
        {
            path: '/Test/Scan/', ///Test/Scan
            name: 'TEST01A',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/出貨掃描/BH3010A批次出貨.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/InventoryManagement/InventoryDivideInquire/', ///Test/Scan
            name: 'IM3010A',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/庫別儲位盤點作業/IM3010A庫別儲位盤點作業.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/BatchManage/BatchShiftInputDetail/',
            name: 'BH4031A',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/批次移倉作業/BH4031A批次移倉作業.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/BatchManage/CheckinToBatchMaster/', ///Test/Scan
            name: 'BH3000A',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/批次繳庫作業/BH3000A批次繳庫作業.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/WebApp/CR3220A最低售價查詢/',
            name: 'CR3220A',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/CustManage/CR3220A最低售價查詢.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/WebApp/CR3221A最低售價查詢/',
            name: 'CR3221A',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/CustManage/CR3221A最低售價查詢.vue'),
            meta: {
                requireAuth: true
            }
        },
        {
            path: '/ErrorDevice',
            name: 'ErrorDevice',
            component: () => import('./views/ErrorDevice.vue')
        },
        {
            path: '/Install', name: 'Install',
            component: () => import(/* webpackChunkName: "about" */ './views/Pages/InstallPage.vue'),
        },
        {
            path: '*',
            name: 'Error',
            component: () => import(/* webpackChunkName: "about" */ './views/Error.vue')
        }
    ]
})